import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

const CustomerAuthContext = createContext(null);

const CUSTOMER_TOKEN_KEY = "partvision_token";

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);

    if (!token) {
      setLoading(false);
      return;
    }

    axios
      .get(`${API}/customer-auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setCustomer(response.data);
      })
      .catch(() => {
        localStorage.removeItem(CUSTOMER_TOKEN_KEY);
        setCustomer(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const loginWithOTP = async (mobile, accessToken, requestId) => {
    const response = await axios.post(`${API}/customer-auth/verify`, {
      mobile,
      access_token: accessToken,
      request_id: requestId,
    });

    localStorage.setItem(
      CUSTOMER_TOKEN_KEY,
      response.data.access_token
    );

    setCustomer(response.data.user);

    return response.data.user;
  };

  const updateCustomer = (updatedCustomer) => {
    setCustomer(updatedCustomer);
  };

  const logout = () => {
    localStorage.removeItem(CUSTOMER_TOKEN_KEY);
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider
      value={{
        customer,
        loading,
        loginWithOTP,
        updateCustomer,
        logout,
        isAuthenticated: !!customer,
      }}
    >
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
